import { useEffect } from "react";

/**
 * Adds `is-in` to every `.reveal` element inside `rootRef` (or the whole
 * document) as it scrolls into view. Lightweight IntersectionObserver.
 * Re-runs when `deps` change (e.g. route/language change re-mounts content).
 */
export default function useReveal(rootRef, deps = []) {
  useEffect(() => {
    const root = rootRef?.current || document;
    const els = root.querySelectorAll(".reveal:not(.is-in)");
    if (!els.length) return;

    if (typeof IntersectionObserver === "undefined") {
      els.forEach((el) => el.classList.add("is-in"));
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
